import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const Movies = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddMovie = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditMovie = () => {
  return (
    
      
        <Edit />
      
    
  );
};
